// data/languages/swahili/categories/animaux.ts
import { CategoryData } from '../../../../types/types';
export const animaux: CategoryData = {
  'Mbwa': { translation: 'Chien', translationEn: 'Dog', audio: 'Sw-mbwa', illustration: '🐕' },
  'Paka': { translation: 'Chat', translationEn: 'Cat', audio: 'Sw-paka', illustration: '🐈' },
  'Bata': { translation: 'Canard', translationEn: 'Duck', audio: 'Sw-bata', illustration: '🦆' },
  'Farasi': { translation: 'Cheval', translationEn: 'Horse', audio: 'Sw-farasi', illustration: '🐎' },
  'Nguruwe': { translation: 'Porc', translationEn: 'Pig', audio: 'Sw-nguruwe', illustration: '🐷' },
  'Kasa': { translation: 'Tortue', translationEn: 'Turtle', audio: 'Sw-kasa', illustration: '🐢' },
  'Ng\'ombe': { translation: 'Vache', translationEn: 'Cow', audio: 'Sw-ngombe', illustration: '🐄' },
  'Mbuzi': { translation: 'Chèvre', translationEn: 'Goat', audio: 'Sw-mbuzi', illustration: '🐐' },
  'Kondoo': { translation: 'Mouton', translationEn: 'Sheep', audio: 'Sw-kondoo', illustration: '🐑' },
   'Kulungu': { translation: 'Biche', translationEn: 'Deer', audio: 'Sw-Kulungu', illustration: '🦌' },
  'Kuku': { translation: 'Poule', translationEn: 'Hen', audio: 'Sw-kuku', illustration: '🐔' },
  'Ndege': { translation: 'Oiseau', translationEn: 'Bird', audio: 'Sw-ndege', illustration: '🐦' },
  'Samaki': { translation: 'Poisson', translationEn: 'Fish', audio: 'Sw-samaki', illustration: '🐟' },
  'Ndovu': { translation: 'Éléphant', translationEn: 'Elephant', illustration: '🐘' },
  'Simba': { translation: 'Lion', translationEn: 'Lion', audio: 'Sw-simba', illustration: '🦁' },
  'Fisi': { translation: 'Hyène', translationEn: 'Hyena', audio: 'Sw-fisi', illustration: '🐺' },
    'Dubu': { translation: 'Ours', translationEn: 'Bear', audio: 'Sw-dubu', illustration: '🐻' },
      'Mbwa mwitu': { translation: 'Loup', translationEn: 'Wolf', audio: 'Sw-Mbwa_mwitu', illustration: '🐺' },
  'Nyoka': { translation: 'Serpent', translationEn: 'Snake', audio: 'Sw-nyoka', illustration: '🐍' },
  'Punda': { translation: 'Âne', translationEn: 'Donkey', audio: 'Sw-punda', illustration: '🐴' },
  'Punda milia': { translation: 'Zèbre', translationEn: 'Zebra', audio: 'Sw-punda_milia', illustration: '🦓' },
  'Panya': { translation: 'Souris', translationEn: 'Mouse', audio: 'Sw-panya', illustration: '🐭' },
  'Mamba': { translation: 'Crocodile', translationEn: 'Crocodile', audio: 'Sw-mamba', illustration: '🐊' },
  'Tumbili': { translation: 'Singe', translationEn: 'Monkey', audio: 'Sw-tumbili', illustration: '🐒' },
  'Mbweha': { translation: 'Chacal', translationEn: 'Jackal', audio: 'Sw-mbweha', illustration: '🐺' },
  'Chui': { translation: 'Panthère / Léopard', translationEn: 'Panther / Leopard', audio: 'Sw-chui', illustration: '🐆' },
  'Kiboko': { translation: 'Hippopotame', translationEn: 'Hippopotamus', audio: 'Sw-kiboko', illustration: '🦛' },
  'Swala': { translation: 'Gazelle / Antilope', translationEn: 'Gazelle / Antelope', audio: 'Sw-swala', illustration: '🦌' },
  'Twiga': { translation: 'Girafe', translationEn: 'Giraffe', audio: 'Sw-twiga', illustration: '🦒' },
  'Nyangumi': { translation: 'Baleine', translationEn: 'Whale', audio: 'Sw-nyangumi', illustration: '🐋' },
  'Chura': { translation: 'Grenouille', translationEn: 'Frog', audio: 'Sw-chura', illustration: '🐸' },
 
  'Kobe': { translation: 'Tortue', translationEn: 'Tortoise', illustration: '🐢' },
  'Sungura': { translation: 'Lièvre / Lapin', translationEn: 'Hare / Rabbit', audio: 'Sw-sungura', illustration: '🐰' },
 
  'Kozi': { translation: 'Faucon', translationEn: 'Falcon', audio: 'Sw-kozi', illustration: '🦅' },
  'Nyuki': { translation: 'Abeille', translationEn: 'Bee', audio: 'Sw-nyuki', illustration: '🐝' },
  
  
  'Tumnili': { translation: 'Singe', translationEn: 'Monkey', audio: 'Sw-tumbili', illustration: '🐒' },
  'Kifaru': { translation: 'Rhinocéros', translationEn: 'Rhinoceros', audio: 'Sw-Kifaru', illustration: '🦏' },
  
};
export default animaux;
export {};
